export function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(sessionStorage.getItem('user'));

    if (user) {
        return { 'Authorization': 'Bearer ' + user };
    } else {
        return {};
    }
}